import { extendTheme, ThemeConfig, ThemeOverride } from "@chakra-ui/react";

import breakpoints from "./breakpoints";
import colors from "./colors";
import AppLayout from "./components/app-layout";
import Button from "./components/button";
import card from "./components/card";
import dataTable from "./components/data-table";
import form from "./components/form-control";
import input from "./components/input";
import interactiveTable from "./components/interactive-table";
import list from "./components/list";
import TabLink from "./components/tab-link";
import table from "./components/table";
import text from "./components/text";
import fonts from "./fonts";
import semanticTokens from "./semantic-tokens";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false
};

const overrides: ThemeOverride = {
  components: {
    AppLayout,
    TabLink,
    Button,
    card,
    input,
    form,
    dataTable,
    list,
    interactiveTable,
    table,
    text
  },
  fonts,
  breakpoints,
  semanticTokens,
  colors,
  config
};

export default extendTheme(overrides);
